import type { AvatarBlockProps } from '@ksyos/design-system/dist/components/avatar-block';
import { DateTime } from '@ksyos/date-time';
import { AvatarBlock } from '@ksyos/design-system';
import type { OutpatientClinicTaskNoteWithPractitionerAndWithoutTask } from '@common/contexts/support/domain/types/customOutpatientClinicTaskTypes';
import { translateKey } from '@frontend/translate';
import type { IPerson } from '../../../../common/utils/getDisplayName';
import { getDisplayInitials } from '../../../../common/utils/getDisplayInitials';
import { getDisplayName } from '../../../../common/utils/getDisplayName';

interface IPatientTaskNoteHeader {
    note: OutpatientClinicTaskNoteWithPractitionerAndWithoutTask;
    size?: AvatarBlockProps['size'];
}

const formatDate = (date: DateTime | Date | string) => DateTime.from(date).format('DD MMMM YYYY | HH:mm');

export function PatientTaskNoteHeader(props: IPatientTaskNoteHeader) {
    const editionDateText =
        props.note.updated_at && props.note.created_at !== props.note.updated_at
            ? ` - Bewerkt: ${formatDate(props.note.updated_at)}`
            : '';

    const createdAtDateText = props.note.created_at ? formatDate(props.note.created_at) : '';

    return (
        <AvatarBlock
            altText={props.note.practitioner ? getDisplayName(props.note.practitioner as IPerson) : undefined}
            imageUrl={props.note.practitioner ? props.note.practitioner.profilePictureUrl : undefined}
            initials={props.note.practitioner ? getDisplayInitials(props.note.practitioner as IPerson) : undefined}
            size={props.size ?? 'small'}
            subtitle={createdAtDateText + editionDateText}
            title={props.note.practitioner ? getDisplayName(props.note.practitioner) : translateKey('common.unknown')}
        />
    );
}
